import RangePickerMonths from './range-picker-months';

export default RangePickerMonths;
